import ApplicationController from './application_controller';

// Connects to data-controller="form"
export default class extends ApplicationController {
  static targets = ['inputSearch'];

  isComposing = false;

  connect() {
    super.connect();

    if (this.hasInputSearchTarget) {
      this.inputSearchTarget.addEventListener('compositionstart', () => {
        this.isComposing = true;
      });

      this.inputSearchTarget.addEventListener('compositionend', () => {
        this.isComposing = false;
        this.instantSearch();
      });
    }
  }

  instantSearch() {
    if (this.isComposing) return;

    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, 400);
  }

  submit() {
    this.element.requestSubmit();
  }
}
